var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                sm: "6",
              },
            },
            [
              _c(
                "v-menu",
                {
                  ref: "showDateDialog",
                  attrs: {
                    "close-on-content-click": false,
                    "return-value": _vm.dateSelect,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto",
                  },
                  on: {
                    "update:returnValue": function ($event) {
                      _vm.dateSelect = $event
                    },
                    "update:return-value": function ($event) {
                      _vm.dateSelect = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (_ref) {
                        var on = _ref.on,
                          attrs = _ref.attrs
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    "prepend-icon": "mdi-calendar",
                                    outlined: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.dateSelectDisplay,
                                    callback: function ($$v) {
                                      _vm.dateSelectDisplay = $$v
                                    },
                                    expression: "dateSelectDisplay",
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.showDateDialog,
                    callback: function ($$v) {
                      _vm.showDateDialog = $$v
                    },
                    expression: "showDateDialog",
                  },
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: {
                      "no-title": "",
                    },
                    on: {
                      change: function ($event) {
                        _vm.$refs.showDateDialog.save(_vm.dateSelectDisplay)
                        _vm.showDateDialog = false
                        _vm.getReportDaily()
                      },
                    },
                    model: {
                      value: _vm.dateSelect,
                      callback: function ($$v) {
                        _vm.dateSelect = $$v
                      },
                      expression: "dateSelect",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt-5",
        },
        [
          _c("v-simple-table", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c("thead", [
                      _c(
                        "tr",
                        {
                          staticClass: "bg-dark",
                        },
                        [
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              วันที่\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              ยอดแทง\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              ยอดถูก\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              รายจ่ายรวม\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              คงเหลือ\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              ค่าแนะนำ\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              vip\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              bonusยิง\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              bonusคืน\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [
                              _vm._v(
                                "\n              bonusวันเกิด\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              โปรโมท\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [
                              _vm._v(
                                "\n              จำนวนผู้เล่น\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              ยอดเบิ้ล\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                            },
                            [_vm._v("\n              ยอดตอง\n            ")]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.dataResult, function (item) {
                          return _c(
                            "tr",
                            {
                              key: item.id,
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass: "text-center text-no-wrap",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.report_date) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-success text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(item.amount_all).toLocaleString(
                                          "en-US"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-warning text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(
                                          item.amount_win_all
                                        ).toLocaleString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-danger text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(
                                          item.amount_credit_all
                                        ).toLocaleString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  class:
                                    item.amount_total > 0
                                      ? "text-right text-success"
                                      : "text-right text-danger",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(
                                          item.amount_total
                                        ).toLocaleString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-warning text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(item.amount_aff).toLocaleString(
                                          "en-US"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-warning text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(item.amount_vip).toLocaleString(
                                          "en-US"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-warning text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(
                                          item.amount_bonus
                                        ).toLocaleString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-warning text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(
                                          item.amount_credit_back
                                        ).toLocaleString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-warning text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(item.amount_hbd).toLocaleString(
                                          "en-US"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-warning text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(
                                          item.amount_promotion
                                        ).toLocaleString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-info text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(item.count_user).toLocaleString(
                                          "en-US"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-info text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(
                                          item.count_double
                                        ).toLocaleString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-info text-right",
                                  attrs: {
                                    align: "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Number(
                                          item.count_triple
                                        ).toLocaleString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              attrs: {
                                align: "center",
                              },
                            },
                            [_vm._v("\n              รวม\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-success text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_all
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-warning text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_win_all
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-danger text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_credit_all
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class:
                                _vm.dataResult.reduce(function (sum, amount) {
                                  return sum + amount.amount_total
                                }, 0) > 0
                                  ? "text-right text-success"
                                  : "text-right text-danger",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_total
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-warning text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_aff
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-warning text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_vip
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-warning text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_bonus
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-warning text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_credit_back
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-warning text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_hbd
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-warning text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.amount_promotion
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-info text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.count_user
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-info text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.count_double
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-info text-right",
                              attrs: {
                                align: "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      _vm.dataResult.reduce(function (
                                        sum,
                                        amount
                                      ) {
                                        return sum + amount.count_triple
                                      },
                                      0)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.preload
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                width: "500",
                "max-width": "100vw",
              },
              model: {
                value: _vm.preload,
                callback: function ($$v) {
                  _vm.preload = $$v
                },
                expression: "preload",
              },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-md-10 mx-lg-auto",
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "text-center",
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          size: 100,
                          width: 10,
                          indeterminate: "",
                          color: "primary",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }